// extracted by mini-css-extract-plugin
export var card = "PilesSVG-module--card--f5af3";
export var container = "PilesSVG-module--container--fb296";